<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <fIter-for-grid
          @renderGridWithFilter="setSearchedPageFilters"
          :gridSearchDataManual="searchedPageFilters"
          :PackageQueryState="gridSearchData.PackageQueryState"
        ></fIter-for-grid>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :pageSizeManual="pageSizeManual"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('userSender') },
                { title: $t('OperatorInfo') },
                { title: $t('Cost') },
                { title: $t('CustomerName') },
                { title: $t('RecipientName') },
                { title: $t('Freight') },
                { title: $t('OrderNumber') },
                { title: $t('billOfLadingNumber') },
                { title: $t('CreateOn') },
                { title: $t('SalePersonName') },
                { title: $t('Description') },
                { title: $t('PackageInfo') },
              ]"
            >
              <template slot-scope="{ row, pagination }">
                <td style="width: 10%">
                  {{
                    row.checkOutInfo ? row.checkOutInfo.issuerUserName : "---"
                  }}
                </td>

                <td style="width: 9%">
                  {{ row.operatorInfo ? row.operatorInfo.nickName : "---" }}
                </td>
                <td style="width: 10%">
                  {{ row.cost ? Number(row.cost).toLocaleString() : "---" }}
                </td>
                <td style="width: 9%">
                  {{ row.partyName }}
                </td>
                <td style="width: 10%">
                  {{
                    row.recipientInfo ? row.recipientInfo.recipientName : "---"
                  }}
                </td>
                <td style="width: 10%">
                  {{
                    row.transportsFleetInfo
                      ? row.transportsFleetInfo.name
                      : "---"
                  }}
                </td>
                <td style="width: 9%">
                  {{ row.draftOrderInfo ? row.draftOrderInfo.basketId : "---" }}
                </td>
                <td style="width: 9%; direction: ltr">
                  {{ row.billOfLadingNumber ? row.billOfLadingNumber : "---" }}
                </td>
                <td style="width: 8%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 10%">
                  {{ row.salePersonInfo ? row.salePersonInfo.name : "---" }}
                </td>
                <td style="width: 10%">
                  {{ row.description ? row.description : "---" }}
                </td>
                <td style="width: 5%">
                  <router-link
                    :to="{
                      path: '/Package/Details/' + tabIndex + '/' + row.id,
                      query: {
                        gridSearchData,
                        numberRowsPerPage: pagination.pageSize,
                        breadcrumbNameManual: {
                          persianTitle: 'مرسولات',
                          Title: 'Package',
                        },
                      },
                    }"
                  >
                    <vs-button
                      radius
                      color="success"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="d-inline"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FIterForGrid from "../../../components/extra-components/FilterForGrid.vue";

export default {
  name: "",
  components: {
    DataGrid,
    FIterForGrid,
  },
  props: {
    tabIndex: { default: "" },
    searchedPageFilters: {},
    numberRowsPerPage: {
      default: -1,
    },
  },
  data() {
    return {
      pageSizeManual: 10,
      gridDataSource: { data: [] },
      gridSearchData: {
        PackageQueryState: "2",
      },
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "Shipping/api/PackagesQuery",
    };
    if (this.searchedPageFilters.PackageQueryState) {
      this.setSearchedPageFilters(this.searchedPageFilters);
    } else {
      this.renderGrid();
    }
  },
  methods: {
    setSearchedPageFilters(gridSearch) {
      this.gridSearchData = JSON.parse(JSON.stringify(gridSearch));
      this.gridSearchData.PackageQueryState = 2;
      this.renderGrid();
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 200);
    },
  },
};
</script>
